<template>
  <el-dialog :title="$t('merchantShop.addShop')" :visible.sync="dialogVisible" width="60%" @close="closeDialog">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="right">
      <el-form-item :label="$t('merchantShop.shopType')" prop="shopType">
        <el-select v-model="form.shopType" :placeholder="$t('merchantShop.selectShopType')" style="width:100%">
          <el-option v-for="item in shopTypes" :key="item.shopTypeId" :label="item.typeName" :value="item.shopTypeId" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('merchantShop.shopArea')" prop="selectProv">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-select v-model="form.selectProv" :placeholder="$t('merchantShop.selectProvince')" style="width:100%"
              @change="getProv">
              <el-option v-for="item in provs" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="form.selectCity" :placeholder="$t('merchantShop.selectCity')" style="width:100%"
              @change="getCity" :disabled="!form.selectProv">
              <el-option v-for="item in citys" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" />
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="form.selectArea" :placeholder="$t('merchantShop.selectArea')" style="width:100%"
              @change="getArea" :disabled="!form.selectCity">
              <el-option v-for="item in areas" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" />
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item :label="$t('merchantShop.shopName')" prop="shopName">
        <el-input v-model="form.shopName" :placeholder="$t('merchantShop.inputShopName')" />
      </el-form-item>

      <el-form-item :label="$t('merchantShop.address')" prop="address">
        <el-input v-model="form.address" :placeholder="$t('merchantShop.inputAddress')" />
      </el-form-item>

      <el-form-item :label="$t('merchantShop.phone')" prop="tel">
        <el-input v-model="form.tel" :placeholder="$t('merchantShop.inputPhone')" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveMerchantShopInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addShop, getShopTypes, getAreas } from '@/api/admin/merchantShopApi'

export default {
  name: 'AddMerchantShopInfo',
  data() {
    return {
      dialogVisible: false,
      form: {
        storeId: '',
        shopName: '',
        areaAddress: '',
        address: '',
        tel: '',
        areaCode: '',
        shopType: '',
        selectProv: '',
        selectCity: '',
        selectArea: ''
      },
      shopTypes: [],
      provs: [],
      citys: [],
      areas: [],
      rules: {
        shopType: [
          { required: true, message: this.$t('merchantShop.selectShopType'), trigger: 'change' }
        ],
        selectProv: [
          { required: true, message: this.$t('merchantShop.selectProvince'), trigger: 'change' }
        ],
        shopName: [
          { required: true, message: this.$t('merchantShop.inputShopName'), trigger: 'blur' },
          { max: 200, message: this.$t('merchantShop.shopNameMaxLength'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('merchantShop.inputAddress'), trigger: 'blur' },
          { max: 200, message: this.$t('merchantShop.addressMaxLength'), trigger: 'blur' }
        ],
        tel: [
          { required: true, message: this.$t('merchantShop.inputPhone'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('merchantShop.phoneFormat'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.form.storeId = params.storeId
      this._initArea('101', '0')
      this._listShopTypes()
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.form = {
        storeId: '',
        shopName: '',
        areaAddress: '',
        address: '',
        tel: '',
        areaCode: '',
        shopType: '',
        selectProv: '',
        selectCity: '',
        selectArea: ''
      }
    },
    async saveMerchantShopInfo() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          await addShop(this.form)
          this.$emit('refresh')
          this.closeDialog()
          this.$message.success(this.$t('merchantShop.addSuccess'))
        } catch (error) {
          console.error('添加商铺失败:', error)
          this.$message.error(error.message || this.$t('merchantShop.addFailed'))
        }
      })
    },
    getProv(prov) {
      this._initArea('202', prov)
    },
    getCity(city) {
      this._initArea('303', city)
    },
    getArea(area) {
      this.form.areaCode = area
      this.form.areaAddress = ''
      if (this.provs) {
        const prov = this.provs.find(item => item.areaCode === this.form.selectProv)
        if (prov) this.form.areaAddress += prov.areaName
      }
      if (this.citys) {
        const city = this.citys.find(item => item.areaCode === this.form.selectCity)
        if (city) this.form.areaAddress += city.areaName
      }
      if (this.areas) {
        const area = this.areas.find(item => item.areaCode === this.form.selectArea)
        if (area) this.form.areaAddress += area.areaName
      }
    },
    async _initArea(areaLevel, parentAreaCode) {
      try {
        const res = await getAreas({ areaLevel, parentAreaCode })
        if (areaLevel === '101') {
          this.provs = res.data
        } else if (areaLevel === '202') {
          this.citys = res.data
        } else {
          this.areas = res.data
        }
      } catch (error) {
        console.error('获取地区失败:', error)
        this.$message.error(this.$t('merchantShop.getAreaFailed'))
      }
    },
    async _listShopTypes() {
      try {
        const res = await getShopTypes({ page: 1, row: 100 })
        this.shopTypes = res.data
      } catch (error) {
        console.error('获取商铺类型失败:', error)
      }
    }
  }
}
</script>